var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5CFCEFB4-156E-44D7-9908-8B03AC57599F@1.00x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WEB-MobileFirst",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "currentfILL",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0024727,30.0199896 L51.0001039,30.0199896 C51.5520831,30.0199896 52,29.5719896 52,29.0200935 C52,28.4681143 51.552,28.0201974 51.0001039,28.0201974 L21.0024727,28.0201974 C20.4504935,28.0201974 20.0025766,28.4681974 20.0025766,29.0200935 C20.0025766,29.5719896 20.4505766,30.0199896 21.0024727,30.0199896 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero",
    transform: "translate(36.001288, 29.020094) scale(-1, 1) translate(-36.001288, -29.020094) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0001039,35.0196364 L21.0024727,35.0196364 C20.4504935,35.0196364 20.0025766,35.4676364 20.0025766,36.0195325 C20.0025766,36.5714286 20.4505766,37.0194286 21.0024727,37.0194286 L51.0001039,37.0194286 C51.5520831,37.0194286 52,36.5714286 52,36.0195325 C52,35.4676364 51.5520831,35.0196364 51.0001039,35.0196364 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero",
    transform: "translate(36.001288, 36.019532) scale(-1, 1) translate(-36.001288, -36.019532) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0008935,42.0190753 L21.0024727,42.0190753 C20.4504935,42.0190753 20.0025766,42.4670753 20.0025766,43.0189714 C20.0025766,43.5709506 20.4505766,44.0188675 21.0024727,44.0188675 L41.0008935,44.0188675 C41.5528727,44.0188675 42.0007896,43.5708675 42.0007896,43.0189714 C42.0007896,42.4669922 41.5528727,42.0190753 41.0008935,42.0190753 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero",
    transform: "translate(31.001683, 43.018971) scale(-1, 1) translate(-31.001683, -43.018971) "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu);
export default __webpack_public_path__ + "static/media/icon_menu.9389e5288e229eab8358f9204d816220.svg";
export { ForwardRef as ReactComponent };